
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useGlobalData } from "../context/GlobalDataContext";
import { Link } from "react-router-dom";
import "./JobTablePage.css";

const TABLE_PAGE_LIMIT = 29;

function JobTablePage() {
  const { threeTable, fetchThreeTableSection } = useGlobalData();
  const [isUpdating, setIsUpdating] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [localJobs, setLocalJobs] = useState([]);
  // Removed unused initialLoadDone state
  const tableWrapperRef = useRef(null);

  // Initial + paginated load
  const loadJobs = useCallback(async (nextOffset = 0, isInitial = false) => {
    setIsUpdating(true);
    try {
      await fetchThreeTableSection("jobs", false, {
        preferLoadedData: false,
        fetchIfPartial: false,
        showLoading: false,
        skipLoader: !isInitial,
        limit: TABLE_PAGE_LIMIT,
        offset: nextOffset
      });
      setHasMore(true);
      setOffset(nextOffset);
      // Removed setInitialLoadDone as it's unused
    } finally {
      setIsUpdating(false);
    }
  }, [fetchThreeTableSection]);

  // Sync localJobs with context jobs after fetch
  useEffect(() => {
    // Only update on initial load (offset 0)
    if (offset === 0) {
      setLocalJobs(threeTable.jobs || []);
      setHasMore((threeTable.jobs || []).length === TABLE_PAGE_LIMIT);
      setOffset((threeTable.jobs || []).length);
    }
  }, [threeTable.jobs, offset]);


  // On mount: agar global state me data hai to wahi use karo, warna API call karo (aur skeleton dikhao)
  useEffect(() => {
    if ((threeTable.jobs || []).length > 0) {
      setLocalJobs(threeTable.jobs);
      setHasMore(threeTable.jobs.length === TABLE_PAGE_LIMIT);
      setOffset(threeTable.jobs.length);
      // Removed setInitialLoadDone as it's unused
    } else {
      loadJobs(0, true); // skipLoader: false for skeleton
    }
    // eslint-disable-next-line
  }, []);

  // Infinite scroll: detect when table bottom is visible in viewport
  useEffect(() => {
    const handleScroll = () => {
      if (!hasMore || isUpdating) return;
      const el = tableWrapperRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (rect.bottom <= window.innerHeight + 200) {
        loadJobs(offset, false); // skipLoader: true for scroll
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, isUpdating, offset, loadJobs]);

  const jobs = localJobs.filter(job => job.showOnHome === true);

  return (
    <div className="job-table-container">
      <h2>All Jobs</h2>
      <div
        className="job-table-wrapper"
        ref={tableWrapperRef}
      >
        <table className="job-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((job) => (
              <tr key={job._id}>
                <td>{job.title}</td>
                <td>
                  <Link to={`/mform/${job.slug}`}>Job View</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Status messages below the table */}
      {isUpdating && localJobs.length === 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading jobs...
        </p>
      )}
      {isUpdating && localJobs.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading more jobs...
        </p>
      )}
      {!isUpdating && !hasMore && localJobs.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#888" }}>
          No more jobs.
        </p>
      )}
    </div>
  );
}

export default JobTablePage;
